import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-24 text-center" data-testid="404-page">
      <div className="font-display text-[160px] leading-none text-[#2B2127] md:text-[240px]">
        4<span className="font-display-soft">0</span>4
      </div>
      <h1 className="mt-4 font-display text-3xl md:text-5xl">This page drifted away</h1>
      <p className="mt-4 max-w-md mx-auto text-[#6B5158]">The page you're looking for may have moved or no longer exists. Let's get you back to something beautiful.</p>
      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Link to="/" className="rounded-full bg-[#2B2127] px-7 py-3.5 text-sm text-white hover:bg-[#9D5C6C]">Back to home</Link>
        <Link to="/catalog" className="rounded-full border border-[#2B2127] px-7 py-3.5 text-sm text-[#2B2127] hover:bg-[#2B2127] hover:text-white">
          Explore the shop <ArrowRight size={14} className="ml-1 inline-block" />
        </Link>
      </div>
    </div>
  );
}
